import { fetchOpsKpisV2 } from '@/lib/operations/ordersApi';
import { periodoInicialDeOps } from '@/lib/operations/vistaInicialDeOps';

/**
 * La consulta de los KPIs de Operaciones, como OPCIONES reutilizables.
 *
 * ⭐ EXISTE POR LA MISMA RAZON QUE `opsOrdersQuery`: que la RUTA y la PANTALLA compartan una sola
 *    definicion. Si la clave se escribiera dos veces, la precarga calentaria una casilla que la
 *    pantalla no lee — que es exactamente lo que estaba pasando con la lista y tardamos en ver,
 *    porque una precarga rota no se ve rota: se ve lenta.
 *
 * 🪤 EL PERIODO SALE DE LA VISTA INICIAL, no de un valor escrito aca. Las colas abren mirando todo
 *    el historico y Ventas los ultimos dias; si este archivo eligiera el suyo, volveriamos a tener
 *    dos criterios y dos casillas.
 */
export function opcionesKpisOps(tenantId: string, variante: string, stages: readonly string[]) {
  /*
   * 🚨 ACA HABIA UNA TERCERA COPIA DE LA MISMA REGLA, y la escribi yo — en el mismo dia en que
   *    arregle las otras dos. Decia `variante === 'ventas' ? '7d' : 'todo'`, asi que para
   *    Canceladas pedia todo el historico mientras la pantalla pedia 7 dias: la precarga de sus
   *    KPIs calentaba una casilla que nadie leia, y la barra mostraba un cargando.
   *
   *    El founder lo vio antes que yo: «solo las canceladas sale un pequenio loading».
   *
   * 🪤 TRES COPIAS DE UNA REGLA EN UN DIA. No fue distraccion: fue que la regla vivia en un lugar
   *    incomodo de alcanzar, asi que cada archivo la reescribia. La leccion no es «tener mas
   *    cuidado», es que si un dato se copia tres veces, el problema es donde esta guardado.
   */
  const periodo = periodoInicialDeOps(variante);
  return {
    queryKey: ['ops-kpis', tenantId, stages.join(','), periodo],
    // Un KPI es una foto del negocio, no un dato operativo: medio minuto de antiguedad no cambia
    // ninguna decision, y recalcularlo en cada vuelta a la pantalla si cuesta.
    staleTime: 30_000,
    queryFn: () => fetchOpsKpisV2(tenantId, [...stages], periodo),
  };
}
